import React from "react";
import { Button } from "react-bootstrap";
import {
  ApproveIcon,
  CancelIcon,
  UnApproveIcon,
} from "../gui_components/Icons.js";

export class CreditMemoModuleToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowApproveButton: this.props.isShowApproveButton,
      isShowUnApproveButton: this.props.isShowUnApproveButton,
      isShowCancelButton: this.props.isShowCancelButton,
      isShowApplyToInvoiceButton: this.props.isShowApplyToInvoiceButton,
      isShowRefundButton: this.props.isShowRefundButton,
      isShowLoadCustomerReturnButton: this.props.isShowLoadCustomerReturnButton,
      isShowApprovePrintButton: this.props.isShowApprovePrintButton,
      isShowAdjustButton: this.props.isShowAdjustButton,
      isShowExcelButton: this.props.isShowExcelButton,
    };
  }
  componentDidMount() {
    //
  }
  componentDidUpdate() {
    //
  }
  cancelCreditMemo = (e) => {
    if (e.detail === 1) this.props.cancelCreditMemo();
  };
  approveCreditMemo = (e) => {
    if (e.detail === 1) this.props.approveCreditMemo();
  };
  unApproveCreditMemo = (e) => {
    if (e.detail === 1) this.props.unApproveCreditMemo();
  };
  applyToInvoice = (e) => {
    if (e.detail === 1) this.props.applyToInvoice();
  };
  returnToCustomer = (e) => {
    if (e.detail === 1) this.props.returnToCustomer();
  };
  loadCustomerReturn = (e) => {
    if (e.detail === 1) this.props.loadCustomerReturn();
  };
  approveAndPrint = (e) => {
    if (e.detail === 1) this.props.approveAndPrint();
  };
  adjustCreditMemo = (e) => {
    if (e.detail === 1) this.props.adjustCreditMemo();
  };
  generateExcel = (e) => {
    if (e.detail === 1) this.props.generateExcel();
  };
  render() {
    return (
      <>
        {this.props.isShowApproveButton && (
          <Button
            className="header_buttons"
            size="sm"
            onClick={(e) => this.approveCreditMemo(e)}
          >
            <ApproveIcon />
            Approve
          </Button>
        )}
        {this.props.isShowUnApproveButton && (
          <Button
            className="header_buttons"
            size="sm"
            onClick={(e) => this.unApproveCreditMemo(e)}
          >
            <UnApproveIcon />
            UnApprove
          </Button>
        )}
        {this.props.isShowApplyToInvoiceButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.applyToInvoice(e)}
          >
            Apply To Invoice
          </Button>
        )}
        {this.props.isShowRefundButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.returnToCustomer(e)}
          >
            Refund
          </Button>
        )}
        {this.props.isShowCancelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.cancelCreditMemo(e)}
          >
            <CancelIcon />
            Cancel
          </Button>
        )}

        {this.props.isShowLoadCustomerReturnButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.loadCustomerReturn(e)}
          >
            LoadCustomerReturn
          </Button>
        )}
        {this.props.isShowApprovePrintButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.approveAndPrint(e)}
          >
            <ApproveIcon />
            Approve + Print
          </Button>
        )}
        {this.props.isShowAdjustButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.adjustCreditMemo(e)}
          >
            <ApproveIcon />
            Adjust
          </Button>
        )}
        {this.props.isShowExcelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateExcel(e)}
          >
            Excel
          </Button>
        )}
      </>
    );
  }
}
